import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-logo',
    templateUrl: './logo.component.html',
    styleUrls: ['./logo.component.css', '../../../app.component.css']
})

export class LogoComponent implements OnInit {

    public subdomain: string = "";

    public constructor() { }

    public ngOnInit(): void {

        const hostname: string = window.location.hostname;
        const parts = hostname.split('.');

        if (parts.length > 1) {

            this.subdomain = parts[0];
        }
    }
}
